/**
 * Settings panel — voice STT/TTS providers (ADR-0025): the portal Jarvis
 * assistant's speech edges. Commercial providers (OpenAI / ElevenLabs) take
 * precedence over the self-hosted sidecar (Whisper / Piper), which precedes the
 * browser. Keys are vault-encrypted. Gated `odino:use`.
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { VoiceSettingsForm } from "@/components/odino/VoiceSettingsForm";
import { type VoiceSettings, odinoApi } from "@/lib/api-odino";

export function VoiceSection() {
  const { t } = useTranslation();
  const [voice, setVoice] = useState<VoiceSettings | null>(null);

  useEffect(() => {
    void odinoApi.getVoiceSettings().then(setVoice).catch(() => {});
  }, []);

  return (
    <div className="space-y-3">
      <div>
        <h2 className="text-base font-semibold text-foreground">{t("settings.voice.title", "Voce")}</h2>
        <p className="mt-0.5 text-xs text-muted-foreground">
          {t(
            "settings.voice.subtitle",
            "Provider per ascolto (STT) e voce (TTS) dell'assistente Jarvis del portale. I provider commerciali precedono il sidecar self-hosted, che precede il browser. Le chiavi sono cifrate nel vault.",
          )}
        </p>
      </div>
      <div className="rounded-lg border border-border bg-surface p-5">
        {!voice ? (
          <p className="text-sm text-muted-foreground">{t("common.loading", "Caricamento…")}</p>
        ) : (
          <VoiceSettingsForm settings={voice} onSaved={setVoice} />
        )}
      </div>
    </div>
  );
}
